var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{attrs:{"src":`${_vm.baseUrl}painel/${_vm.link}?token=${_vm.token}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }